const SocialEnum = Object.freeze({
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    INSTAGRAM: 'instagram',
    SNAPCHAT: 'snapchat',
    PINTEREST: 'pinterest',
    YOUTUBE: 'youtube'
});

export default SocialEnum;
